export enum CountryStatus {
  ENABLED_FOR_ALL = 'AllEnabled',
  DISABLED_FOR_ALL = 'NoneEnabled',
  ENABLED_FOR_SOME = 'SomeEnabled',
}
